//顶部菜单
export const topMenu = [
    {
        name: 'About',
        anchor: 'About'
    },
    {
        name: 'Vision',
        anchor: 'Vision'
    },
    {
        name: 'Approach',
        anchor: 'Approach'
    },
    {
        name: 'Focus Areas',
        anchor: 'FocusAreas'
    },
    {
        name: 'Values',
        anchor: 'Values'
    },
    {
        name: 'Services',
        anchor: 'Services'
    },
    {
        name: 'Contact',
        anchor: 'Contact'
    }
]

//首页主页
export const homePage = {
    title: 'Beyond Capital, Building the Future',
    content: 'Empowering the Future of Web3 Innovation',
    website: 'www.bitgo.capital'
}

//关于我们
export const about = {
    title: 'About Us',
    theFirstSentence: 'Founded in 2023, Bitgo Capital is a new-generation global investment institution dedicated to\n' +
        'discovering and supporting high-potential Web3 startups worldwide.',
    secondSentence: 'We go beyond funding—providing strategic advisory, industry resources, and ecosystem development to\n' +
        'help visionary teams achieve breakthrough growth.'
}

//愿景与使命
export const visionAndMission = {
    title: 'Vision & Mission',
    visionTitle: 'Vision',
    visionContent: 'To be a catalyst for Web3 innovation, shaping the decentralized future.',
    missionTitle: 'Mission',
    missionContent: 'Empower entrepreneurs to transform ideas into impactful realities.',
}

//投资理念
export const approach = {
    title: 'Our Approach',
    item: [
        {
            title: 'Capital Support',
            content: 'Early & growth-stage funding'
        },
        {
            title: 'Strategic Advisory',
            content: 'Guidance on business models & tokenomics'
        },
        {
            title: 'Ecosystem Building',
            content: 'Connecting projects, partners & communities'
        },
        {
            title: 'Resource Integration',
            content: 'Unlocking opportunities via global networks'
        }
    ]
}

// 投资重点
export const focusAreas = {
    title: 'Focus Areas',
    content: 'We focus on pioneering projects across Web3 sectors',
    item: [
        "Blockchain Infrastructure",
        "GameFi & Metaverse",
        "DeFi & Digital Assets",
        "AI & Web3 Integration",
        "Cross-Border Payment & Fintech"
    ]
}

// 核心价值观
export const values = {
    title: 'Core Values',
    item: [
        {
            title: 'Integrity',
            content: 'Transparency and trust in every partnership'
        },
        {
            title: 'Innovation',
            content: 'Embracing bold ideas and disruption'
        },
        {
            title: 'Collaboration',
            content: 'Building together for shared growth'
        },
        {
            title: 'Sustainability',
            content: 'Supporting long-term positive impact'
        }
    ]
}

//我们的服务
export const service = {
    title: 'Our Services',
    content: 'Beyond investment, we provide',
    item: [
        "Market Entry Strategy",
        "Compliance & Risk Advisory",
        "Partnership Development",
        "Talent & Leadership Support"
    ]
}

// 投资哲学
export const investmentPhilosophy = {
    title: 'Investment Philosophy',
    content: 'We believe in long-term value creation, supporting founders who are building beyond hype cycles.'
}

// 全球布局
export const globalPresence = {
    title: 'Global Presence',
    content: 'Bitgo Capital partners with ecosystems across major innovation hubs',
    item: [
        "Hong Kong",
        "Singapore",
        "Europe",
        "United States"
    ]
}

// 我们的优势
export const distinctiveEdge = {
    title: 'Distinctive Edge',
    content: 'What makes Bitgo Capital different?',
    item: [
        {
            title: 'Global Reach',
            content: 'From Asia to Europe to the US'
        },
        {
            title: 'Founder-Centric',
            content: 'We invest in people, not just products'
        },
        {
            title: 'Ecosystem First',
            content: 'Building connections that compound value'
        },
        {
            title: 'Beyond Capital',
            content: 'Strategy, resources, and sustainable growth'
        }
    ]
}

// 知识与洞察
export const knowledgeInsights = {
    title: 'Knowledge & Insights',
    content: 'Not just investors — we\'re industry thinkers.'
}

// 我们的承诺
export const commitment = {
    title: 'Commitment',
    item: [
        "Operate with transparency and accountability",
        "Support projects aligned with global regulatory standards",
        "Drive positive long-term impact in the Web3 ecosystem"
    ]
}

// 联系我们
export const contact = {
    title: 'Contact Us',
    content: 'We welcome ambitious founders and partners to connect with us.',
    email: 'Email',
    website: 'Website'
}

//资讯条幅
export const informationBannerItems = [
    {
        title: 'OneChain Completes $67M Series A Financing Round.',
        media: 'Odaily',
        date: '2026.02.18',
        link: 'https://m.odaily.news/zh-CN/newsflash/469016'
    },
    {
        title: 'OneChain Completes $67M Series A Financing Round.',
        media: 'Linkedin',
        date: '2026.02.18',
        link: 'https://www.linkedin.com/posts/bitgo-capital_congratulations-onechain-announces-the-completion-activity-7429815086757883904-fgkk?utm_source=share&utm_medium=member_ios&rcm=ACoAAE6dDE4BWBEINU915z_HsFlfd_mtS0YBark'
    }
]
